import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const DatasetItem = ({ dataset, refreshSelectedDatasets }) => {
    const navigate = useNavigate();
    const datasetName = dataset.name;
    const datasetDescription = dataset.description;
    const createdAt = dataset.created_at;   

    const checkDataset = async (datasetId) => {
        try {
            navigate('/Datasets/' + datasetId);
            // toast.success("Dataset check initiated successfully.");
            // Optionally refresh the dataset list or specific dataset status
            // refreshDatasets();
        } catch (err) {
            console.error("Error opening dataset:", err);
            toast.error("Failed to initiate dataset check.");
        }
    };

    return (
        <tr>
            <td>
                <input 
                    type="checkbox" 
                    onChange={(e) => {
                        const isChecked = e.target.checked;
                        console.log(`Checkbox for dataset ${dataset.id} is now ${isChecked ? "checked" : "unchecked"}`);
                        // Optionally handle the change event, e.g., update state or call a function
                        refreshSelectedDatasets(dataset.id, isChecked);
                    }}
                />
            </td>

            {/* Dataset Name */}
            <td>
                {datasetName}
            </td>

            {/* Description */}
            <td>
                {datasetDescription}
            </td>

            {/* Created At */}
            <td>{new Date(createdAt).toLocaleString()}</td>

            {/* Number of Samples */}
            <td>
                "Number of Samples Placeholder"
            </td>

            {/* Action Buttons */}
            <td>
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => checkDataset(dataset.id)}
                >
                    Check
                </button>
                {/* {isEditing ? (
                    <>
                        <button className="btn btn-success btn-sm me-2" >
                            Save
                        </button>
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => setIsEditing(false)}
                        >
                            Cancel
                        </button>
                    </>
                ) : (
                    <>
                        <button
                            className="btn btn-warning btn-sm me-2"
                            onClick={() => setIsEditing(true)}
                        >
                            Edit
                        </button>
                        <button
                            className="btn btn-danger btn-sm"
                            // onClick={deleteDataset}
                        >
                            Delete
                        </button>
                    </>
                )} */}
            </td>
        </tr>
    );
};

export default DatasetItem;
